<template>
  <div>
    <dropdown
      :disabled="disabled"
      :items="getItems"
      :value="getConfigValue(value)"
      @change="[setConfigValue($event)]"
      :width="width"
      :rules="validationRules"
    >
      <template
        v-if="!hideTooltip && (!!tooltip || !!helpContent)"
        #append-label
      >
        <tooltip v-if="tooltip" :text="tooltip" />
        <helpIcon v-if="helpContent" :content="helpContent" />
      </template>
    </dropdown>
  </div>
</template>

<script>
/**
 * @fileoverview Config input field for days before default
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

import dropdown from "@/qux-common/qux22/components/molecules/dropdown";
import getValidationRules from "@/util/getValidationRules";
import fieldMap from "./field-map.json";

export default {
  name: "DaysBeforeDefaultField",
  components: { dropdown },
  props: {
    category: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    helpContent: {
      type: String,
    },
    hideTooltip: {
      type: Boolean,
    },
    id: {
      type: String,
    },
    parentField: {
      type: String,
    },
    rules: {
      type: Array,
    },
    tooltip: {
      type: String,
    },
    value: {
      type: [String, Number],
    },
    width: {
      type: String,
    },
  },
  methods: {
    getConfigValue(value) {
      return Number(value);
    },
    /**
     * Sets the value
     */
    setConfigValue(value) {
      this.$emit("setConfigValue", value);
    },
    getFieldValue(value, id = this.id) {
      return (
        fieldMap[this.category] &&
        fieldMap[this.category][id] &&
        fieldMap[this.category][id][value]
      );
    },
  },
  computed: {
    getItems() {
      const values = Array.from(
        { length: this.getFieldValue("maxDays", this.parentField) + 1 || 30 },
        (v, i) => i
      );
      return values.map((value) => ({
        text: value,
        value,
      }));
    },
    validationRules() {
      return getValidationRules({
        rules: this.rules,
        inputErrorMessage: this.getFieldValue("inputErrorMessage"),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>